import { getApiKey } from "../../utils/apiKey";
import React, { Component } from "react";
import axios from "axios";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import Spinner from "../Spinner/Spinner";
import Header from "../header";
import Select from "react-select";
import { apiCall_domain } from "../api";
import { createGlobalStyle } from "styled-components";
class FixedService extends Component {
  state = {
    pageSpinner: true,
    days: [],
    vendorAddress: [],
    index: 0,
    houer: "",
    day: "",
    val: "",
    border: false,
    georgian: "",
    timeId: "",
    depotId: "",
    userId: "",
    error: "",
    value: "1",
    validation: true,
    freeHour: [],
    validationShop: true,
    DeleveryT: 1,
  };

  componentDidMount() {
    const config = {
      Authorization: getApiKey(),
      "content-type": "application/json",
    };
    axios
      .get(`${apiCall_domain}/customer/depots`, {
        headers: config,
      })
      .then((res) => {
        this.setState({ vendorAddress: res.data.data });
      })
      .catch((err) => {});
    axios
      .get(`${apiCall_domain}/customer/depots/times`, { headers: config })
      .then((res) => {
        this.setState({ days: res.data, pageSpinner: false });
      })
      .catch((err) => {});
  }

  render() {
    const GlobalStyles = createGlobalStyle`body{
      background: #F9F9F9;
    }`;
    //FUNCTIONS
    const handleChange = (event, newValue) => {
      this.setState({ value: newValue, depotId: parseInt(newValue) });
    };

    const submited = () => {
      if (this.state.georgian === "") {
        this.setState({ error: "لطفا روز مورد نظر را انتخاب کنید" });
      } else if (this.state.timeId == "") {
        this.setState({ error: "لطفا زمان تحویل را انتخاب کنید" });
      } else if (this.state.depotId === "" && this.state.userId === "") {
        this.setState({ error: "لطفا آدرس مورد نظر را انتخاب کنید" });
      } else {
        if (this.props.location.editCart) {
          const Data1 = {
            count: 1,
            item_id: localStorage.getItem("vendor-item-id"),
            service_type: this.state.index,
            day: this.state.georgian,
            time: this.state.timeId,
            depot_id: this.state.depotId,
            install_need: 1,
          };
          const Data2 = {
            count: 1,
            item_id: localStorage.getItem("vendor-item-id"),
            service_type: this.state.index,
            day: this.state.georgian,
            time: this.state.timeId,
            address_id: this.state.userId,
            install_need: 1,
          };
          const Data3 = {
            count: 1,
            item_id: 117,
            install_need: 0,
          };
          const Data =
            this.state.index === 0
              ? Data1
              : this.state.index === 1
                ? Data2
                : Data3;
          const config = {
            Authorization: getApiKey(),
            "content-type": "application/json",
          };
          axios
            .post(
              `${apiCall_domain}/customer/shopping-cart/update/${this.props.location.idEditCart}`,
              Data,
              {
                headers: config,
              },
            )
            .then((res) => {
              localStorage.setItem("MOveINGdeleveryType", 1);
              this.props.history.push({
                pathname: `/product/${localStorage.getItem("productId")}`,
                path: this.state.validation,
                validationShop: this.state.validationShop,
                DeleveryT: this.state.DeleveryT,
              });
            })
            .catch((err) => {});
        } else {
          const Data1 = {
            count: 1,
            item_id: localStorage.getItem("vendor-item-id"),
            install_need: 1,
            service_type: this.state.index,
            day: this.state.georgian,
            time_id: this.state.timeId,
            depot_id: this.state.depotId,
          };
          const Data2 = {
            count: 1,
            item_id: localStorage.getItem("vendor-item-id"),
            install_need: this.props.location.hasInstall,
            service_type: this.state.index,
            day: this.state.georgian,
            time_id: this.state.timeId,
            address_id: this.state.userId,
            install_need: 1,
          };
          const Data3 = {
            count: 1,
            item_id: 117,
            install_need: 0,
          };
          const Data =
            this.state.index === 0
              ? Data1
              : this.state.index === 1
                ? Data2
                : Data3;
          const config = {
            Authorization: getApiKey(),
            "content-type": "application/json",
          };
          axios
            .post(`${apiCall_domain}/customer/shopping-cart`, Data1, {
              headers: config,
            })
            .then((res) => {
              localStorage.setItem("MOveINGdeleveryType", 1);
              this.props.history.push({
                pathname: `/product/${localStorage.getItem("productId")}`,
                path: this.state.validation,
                DeleveryT: this.state.DeleveryT,
                validationShop: this.state.validationShop,
              });
            })
            .catch((err) => {});
        }
      }
    };

    const handleChangeDays = (selectedOption5) => {
      this.setState({
        selectedOption5,
        freeHour: Object.values(selectedOption5.times),
        date: selectedOption5.id,
        selectedOption6: "زمان ارسال",
        georgian: selectedOption5.georgian,
      });
    };

    const handleChangeHour = (selectedOption6) => {
      this.setState({ selectedOption6, timeId: selectedOption6.id });
    };
    //FUNCTIONS

    return (
      <>
        {this.state.pageSpinner ? (
          <Spinner />
        ) : (
          <>
            <GlobalStyles />
            <Header showSearchBar={true} title={"سرویس نصب ثابت"} />
            <div className="mainFixedService">
              <div className="innerMainFixedService">
                <div className="my-radio-group mySec-radio-group">
                  لیست نمایندگان
                </div>
                <div className="representativesAddress">
                  <FormControl component="fieldset">
                    <RadioGroup
                      name="gender1"
                      value={this.state.value}
                      onChange={handleChange}
                    >
                      {this.state.vendorAddress &&
                        this.state.vendorAddress.map((item, i) => (
                          <FormControlLabel
                            value={`${item.id}`}
                            control={<Radio />}
                            key={i}
                            label={`${item.address}`}
                          />
                        ))}
                    </RadioGroup>
                  </FormControl>
                </div>
                <div className="my-radio-group mySec-radio-group">
                  زمان تحویل
                </div>
                <div className="deliveryTime">
                  <Select
                    value={this.state.selectedOption5}
                    onChange={handleChangeDays}
                    options={this.state.days.map((item) => ({
                      value: item.jalali,
                      label: item.jalali,
                      times: item.hours,
                      georgian: item.georgian,
                      id: item.id,
                    }))}
                    placeholder={"تاریخ"}
                  />
                  <Select
                    value={this.state.selectedOption6}
                    onChange={handleChangeHour}
                    options={this.state.freeHour.map((item) => ({
                      value: `از ${item.start_ts} تا ${item.stop_ts}`,
                      label: `از ${item.start_ts} تا ${item.stop_ts}`,
                      id: item.id,
                    }))}
                    placeholder={"زمان"}
                  />
                </div>

                <div className="error">{this.state.error}</div>

                <div className="secContinue">
                  <button type="submit" onClick={submited}>
                    ادامه
                  </button>
                </div>
              </div>
            </div>
          </>
        )}
      </>
    );
  }
}

export default FixedService;
